import { CaptureConsole } from '@sentry/integrations';
import * as Sentry from '@sentry/react';
import 'models';
import ReactDOM from 'react-dom/client';

import App from './App';
import './haffer.css';
import './i18n';
import './index.css';
import './polyfills';

import Alerts from 'components/Alerts/Alerts';
import EmployerForm from 'components/EmployerForm/EmployerForm';

import env, { EEnvs } from 'constants/env';

import DashboardService from 'services/DashboardService';
import MarketingSiteService from 'services/MarketingSiteService';

if (env.REACT_APP_ENV !== EEnvs.dev) {
    Sentry.init({
        dsn: 'https://78930040ac7e4f9a82324ce902468622@o1030537.ingest.sentry.io/5997775',
        ignoreErrors: ['Non-Error exception captured', 'Non-Error promise rejection captured'],
        replaysSessionSampleRate: 0,
        replaysOnErrorSampleRate: 1.0,
        integrations: [
            new Sentry.BrowserTracing(),
            new CaptureConsole({
                levels: ['error'],
            }),
            new Sentry.Replay({
                maskAllText: false,
                blockAllMedia: false,
            }),
        ],
        environment: env.REACT_APP_ENV,
        release: env.REACT_APP_VERSION,
        tracesSampleRate: 0.2,
    });
}

if (env.REACT_APP_IS_MARKETING) {
    if (!document.getElementById('header')) {
        const header = document.createElement('div');
        header.setAttribute('id', 'header');
        document.body.appendChild(header);
        header.style.display = 'none';
    }

    const headerElement = document.getElementById('header');
    if (headerElement) {
        ReactDOM.createRoot(headerElement).render(<App />);
    }
    document.querySelectorAll(`[id=take_assessment]`)?.forEach?.((button) => {
        try {
            button.removeAttribute('href');
            (button as HTMLAnchorElement).onclick = DashboardService.takeAssessmentButtonClick;
        } catch (error) {
            console.log(error);
        }
    });
    document.querySelectorAll(`[id=take_assessment-simple_product_choice]`)?.forEach?.((button) => {
        try {
            button.removeAttribute('href');
            (button as HTMLAnchorElement).onclick = () =>
                DashboardService.takePreselectedAssessmentButtonClick('simple_product_choice');
        } catch (error) {
            console.log(error);
        }
    });
    document.querySelectorAll(`[id=take_assessment-custom_product_choice]`)?.forEach?.((button) => {
        try {
            button.removeAttribute('href');
            (button as HTMLAnchorElement).onclick = () =>
                DashboardService.takePreselectedAssessmentButtonClick('custom_product_choice');
        } catch (error) {
            console.log(error);
        }
    });
    document.querySelectorAll(`[id=take_assessment-trust_product_choice]`)?.forEach?.((button) => {
        try {
            button.removeAttribute('href');
            (button as HTMLAnchorElement).onclick = () =>
                DashboardService.takePreselectedAssessmentButtonClick('trust_product_choice');
        } catch (error) {
            console.log(error);
        }
    });

    if (!document.getElementById('alerts-root')) {
        const header = document.createElement('alerts-root');
        header.setAttribute('id', 'alerts-root');
        document.body.prepend(header);
        ReactDOM.createRoot(header).render(<Alerts />);
    }

    if (window.location.pathname.startsWith('/benefit-partner')) {
        const formRoot = document.getElementById('benefit-form');
        if (formRoot) {
            ReactDOM.createRoot(formRoot).render(<EmployerForm />);
        }
    }

    const advisorSignupHrefs = Array.from(document.querySelectorAll('a')).filter((i) =>
        i.href.includes('/signup?role=advisor'),
    );
    // eslint-disable-next-line no-script-url
    advisorSignupHrefs.forEach((i) => (i.href = 'javascript:;'));
    advisorSignupHrefs.forEach((i) => (i.onclick = MarketingSiteService.openPreSignupModal));
} else {
    const rootElement = document.getElementById('root');
    if (rootElement) {
        ReactDOM.createRoot(rootElement).render(<App />);
    }
}
